import { DirectionEnum } from '../types/enums';
import { directionFromDelta } from '../cinematic/direction.utils';
import { useGameStore } from '../store/gameSlice';
import { PlayerEntity } from '../entities/PlayerEntity';

class MouseAimService {
  private cursorX = 0;
  private cursorY = 0;
  private hasCursor = false;
  private pendingLeft = false;
  private pendingRight = false;

  public setCursor(x: number, y: number): void {
    this.cursorX = x;
    this.cursorY = y;
    this.hasCursor = true;
  }

  public queueLeftClick(): void {
    this.pendingLeft = true;
  }

  public queueRightClick(): void {
    this.pendingRight = true;
  }

  public consumeLeftClick(): boolean {
    const v = this.pendingLeft;
    this.pendingLeft = false;
    return v;
  }

  public consumeRightClick(): boolean {
    const v = this.pendingRight;
    this.pendingRight = false;
    return v;
  }

  public reset(): void {
    this.pendingLeft = false;
    this.pendingRight = false;
    this.hasCursor = false;
  }

  /**
   * 8-way facing from the player's on-screen position to the cursor. Rotation
   * only — never moves. Returns null until the cursor has been seen or when the
   * cursor sits exactly on the player.
   */
  public getAimDirection(player: PlayerEntity): DirectionEnum | null {
    if (!this.hasCursor) {
      return null;
    }
    const { cameraPosition, screenWidth, screenHeight, zoomFactor } =
      useGameStore.getState();
    const originX =
      screenWidth / 2 + (player.absoluteX - cameraPosition.x) * zoomFactor;
    const originY =
      screenHeight / 2 - (player.absoluteY - cameraPosition.y) * zoomFactor;
    const dx = this.cursorX - originX;
    const dy = this.cursorY - originY;
    if (dx === 0 && dy === 0) {
      return null;
    }
    return directionFromDelta(dx, dy);
  }
}

export const mouseAimService = new MouseAimService();
